// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M26.171 7.534C23.51 6.202 20 5.5 16 5.5c-4 0-7.51.702-10.171 2.034C3.078 8.909 1.5 10.9 1.5 13v6c0 2.099 1.578 4.091 4.329 5.466C8.49 25.797 12.006 26.5 16 26.5c3.994 0 7.51-.703 10.171-2.034C28.921 23.091 30.5 21.1 30.5 19v-6c0-2.099-1.578-4.091-4.329-5.466Zm-19 2.682C9.385 9.11 12.52 8.5 16 8.5c3.48 0 6.615.61 8.829 1.716C26.476 11.04 27.5 12.108 27.5 13c0 .893-1.024 1.96-2.671 2.784C22.615 16.89 19.48 17.5 16 17.5c-3.48 0-6.615-.61-8.829-1.716C5.524 14.96 4.5 13.892 4.5 13c0-.893 1.024-1.96 2.671-2.784ZM22.5 22.673a22.55 22.55 0 0 1-5 .787v-3c1.685-.069 3.36-.3 5-.689v2.901Zm-13-2.895c1.64.389 3.315.62 5 .688v3a22.544 22.544 0 0 1-5-.787v-2.901ZM4.5 19v-1.308c.426.287.87.546 1.329.774.217.109.442.213.671.313v2.634c-1.25-.758-2-1.65-2-2.413Zm21 2.413v-2.634c.229-.1.454-.204.671-.313.46-.229.903-.487 1.329-.774V19c0 .764-.75 1.655-2 2.413Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
